import React, { useState, useEffect } from "react";
import { Grid, Paper } from "@material-ui/core";
import { styled } from "@material-ui/styles";
import { IStyledArguments } from "../../types/styled-arguments";
import ProgressBar from "../progress-bar";
import StepInitial from "./StepInitial";
import { useMutation } from "@apollo/client";
import { gql } from "@apollo/client";
// import useAuthContext from "../../hooks/useAuthContext";
import { injectIntl } from "react-intl";
import Content from "../content";
import Link from "../link";
import Button from "../button";
import { ITeam } from "../../types";

export const ADD_TEAM = gql`
  mutation AddTeam(
    $name: String!
    $location: String!
    $colorHome: String!
    $colorAway: String!
  ) {
    createTeam(
      input: {
        name: $name
        location: $location
        colorHome: $colorHome
        colorAway: $colorAway
      }
    ) {
      id
      name
      location
      colorHome
      colorAway
    }
  }
`;

const StyledActionLink = styled(Link)(({ theme }: IStyledArguments) => {
  return {
    ...theme.typography.caption,
    color: theme.palette.secondary.dark,
    textDecoration: "none",
    textTransform: "uppercase",
  };
});

const ButtonRow = styled("div")(({ theme }: IStyledArguments) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  paddingTop: theme.spacing(2),
}));

const MessageSpace = styled("div")(({ theme }: IStyledArguments) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  paddingTop: theme.spacing(2),
}));

const StyledPaper = styled(Paper)(({ theme }: IStyledArguments) => ({
  boxSizing: "border-box",
  padding: theme.spacing(4),
  marginBottom: theme.spacing(5),
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  margin: "0 auto",
  maxWidth: 630,
  [`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
    boxShadow: "none",
  },
}));

const PageNewTeam = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [team, setTeam] = useState<ITeam>();
  const [addPlayer, { data, loading }] = useMutation(ADD_TEAM);
  const handleAddTeam = async (form: any) => {
    addPlayer({
      variables: {
        name: form.name,
        location: form.location,
        colorHome: form.colorHome,
        colorAway: form.colorAway,
      },
    });
  };

  useEffect(() => {
    if (loading) {
      return;
    }

    if (!data) {
      return;
    } else {
      setTeam(data.createTeam);
      setCurrentStep(2);
    }
  }, [data]);

  if (loading) {
    // TODO: LOADING SPINNER
    return (
      <Content>
        <p>LOADING</p>
      </Content>
    );
  }

  return (
    <Content>
      <Grid container spacing={0} justify="center" alignItems="center">
        <Grid item xs={12} md={6}>
          <StyledPaper>
            <ProgressBar steps={2} activeStep={currentStep} />
            {currentStep === 1 && (
              <StepInitial
                onGoNext={(values: any) => {
                  handleAddTeam(values);
                }}
                team={team}
              />
            )}
            {currentStep === 2 && (
              <Content>
                <svg
                  height="80px"
                  viewBox="0 -3 503.632 503"
                  width="80px"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <linearGradient
                    id="a"
                    gradientUnits="userSpaceOnUse"
                    x1="251.816"
                    x2="251.816"
                    y1="496.316"
                    y2=".316"
                  >
                    <stop offset="0" stop-color="#FF5722" />
                    <stop offset="1" stop-color="#0bb1d3" />
                  </linearGradient>
                  <path
                    d="m379.816406 400.316406v-32h-39.304687c34.457031-33.710937 55.304687-80.496094 55.304687-131.710937v-172.289063h-64v32h-32v-32h-96v32h-32v-32h-64v172.289063c0 51.214843 20.847656 98 55.304688 131.710937h-39.304688v32h-123.816406l19.191406 48-19.191406 48h203.816406v-32h96v32h203.816406l-19.191406-48 19.191406-48zm-256-163.710937v-156.289063h32v32h64v-32h64v32h64v-32h32v156.289063c0 77.894531-52.535156 144.855469-128 163.488281-75.464844-18.625-128-85.59375-128-163.488281zm57.886719 147.710937c19.832031 14.785156 42.863281 25.808594 68.28125 31.792969l1.832031.421875 1.832032-.429688c25.414062-5.976562 48.449218-17.007812 68.28125-31.792968h41.886718v64h-224v-64h41.886719zm-158.070313 32h100.183594v44.945313l38.113282 19.054687h-138.296876l12.808594-32zm164.183594 59.054688-22.113281-11.054688h22.113281zm150.113282-11.054688-22.113282 11.054688v-11.054688zm142.070312 16h-138.296875l38.113281-19.054687v-44.945313h100.183594l-12.808594 32zm-228.183594-128c61.757813 0 112-50.242187 112-112 0-61.761718-50.242187-112-112-112-61.761718 0-112 50.238282-112 112 0 61.757813 50.238282 112 112 112zm-55.382812-119.367187 16.445312 5.480469 6.441406 32.199218-11.785156 17.6875h-38.726562c-6.214844-10.710937-10.410156-22.703125-12.082032-35.511718zm-40.363282 2.292969c.867188-16.351563 5.800782-31.597657 13.867188-44.789063l15.140625 30.285156zm95.746094-16.925782 23.167969 17.375-5.71875 28.625h-34.890625l-5.71875-28.625zm55.382813 14.632813 39.710937 19.855469c-1.671875 12.800781-5.863281 24.800781-12.078125 35.511718h-38.726562l-11.792969-17.679687 6.441406-32.199219zm11.351562-12.210938 15.144531-30.285156c8.066407 13.191406 13.007813 28.4375 13.863282 44.789063zm-138.085937 83.578125h25.582031l8.097656 24.28125c-12.960937-5.554687-24.390625-13.9375-33.679687-24.28125zm52.488281 30.121094-12.3125-36.9375 11.457031-17.183594h39.4375l11.457032 17.183594-12.3125 36.9375c-6.105469 1.214844-12.40625 1.878906-18.863282 1.878906-6.457031 0-12.761718-.664062-18.863281-1.878906zm56.535156-5.839844 8.097657-24.28125h25.582031c-9.289063 10.34375-20.71875 18.726563-33.679688 24.28125zm33.488281-152.488281-20.839843 41.671875-16.871094 5.621094-25.449219-19.085938v-24.160156l33.09375-26.472656c11.457032 5.464844 21.648438 13.105468 30.066406 22.425781zm-47.738281-28.785156-23.421875 18.75-23.425781-18.742188c7.511719-1.894531 15.328125-3.015625 23.425781-3.015625 8.09375 0 15.910156 1.121094 23.421875 3.007813zm-64.519531 6.359375 33.097656 26.472656v24.160156l-25.449218 19.085938-16.871094-5.621094-20.839844-41.671875c8.414062-9.320313 18.609375-16.960937 30.0625-22.425781zm233.097656 174.632812h-16v-16h16zm-16 0v16h-16v-16zm0 32v-16h16v16zm16-16v-16h16v16zm-368-312h-16v-16h16zm-16 0v16h-16v-16zm0 32v-16h16v16zm16-16v-16h16v16zm384-24h-16v-24h16zm-19.3125 1.375-11.3125 11.3125-16.96875-16.96875 11.3125-11.3125zm-36.6875 14.625h24v16h-24zm25.375 19.3125 11.3125 11.3125-16.96875 16.964844-11.3125-11.308594zm30.625 36.6875h-16v-24h16zm20.28125-8.410156-16.96875-16.964844 11.3125-11.3125 16.964844 16.96875zm19.71875-31.589844h-24v-16h24zm-36.6875-30.625 16.96875-16.96875 11.308594 11.3125-16.964844 16.96875zm-403.3125 262.625h-16v-24h16zm-19.3125 1.375-11.3125 11.3125-16.96875-16.96875 11.3125-11.3125zm-12.6875 30.625h-24v-16h24zm1.375 3.3125 11.3125 11.3125-16.96875 16.964844-11.3125-11.308594zm14.625 12.6875h16v24h-16zm36.28125 15.589844-16.96875-16.964844 11.3125-11.3125 16.964844 16.96875zm19.71875-31.589844h-24v-16h24zm-36.6875-30.625 16.96875-16.96875 11.308594 11.3125-16.964844 16.96875zm0 0"
                    fill="url(#a)"
                  />
                </svg>
                <MessageSpace>Team {team && team.name} created</MessageSpace>
                <ButtonRow>
                  <StyledActionLink to="/people/teams">
                    <Button>Ok</Button>
                  </StyledActionLink>
                </ButtonRow>
              </Content>
            )}
          </StyledPaper>
        </Grid>
      </Grid>
    </Content>
  );
};

export default injectIntl(PageNewTeam);
